import React, { useEffect, useState } from 'react';
import { appConfigAPI } from '../services/api';
import { assetUrl } from '../utils/assetUrl';

const logoAnimationStyles = `
  @keyframes spinClockwise {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes subtleZoom {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(0.95); }
  }
  .logo-bg-spin {
    animation: spinClockwise 20s linear infinite;
    opacity: 0.15;
    position: absolute;
    z-index: 0;
  }
  .logo-front-zoom {
    animation: subtleZoom 3s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
`;

export function useAppBrand() {
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    appConfigAPI.get().then((res) => {
      setAppConfig(res.data);
      const faviconHref = assetUrl(res.data.favicon_url);
      if (faviconHref) {
        const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = faviconHref;
        if (!document.querySelector("link[rel='icon']")) {
          document.head.appendChild(favicon);
        }
      }
    }).catch(() => {
      setAppConfig({ app_name: 'eloNest' });
    });
  }, []);

  return appConfig;
}

export default function AuthBrand({ appConfig }) {
  const name = appConfig?.app_name || 'eloNest';
  const appLogoSrc = assetUrl(appConfig?.logo_url);

  return (
    <>
      <style>{logoAnimationStyles}</style>
      {appLogoSrc ? (
        <div className="flex justify-center items-center mb-4 relative" style={{
          minHeight: (appConfig.logo_height || 80) * 1.5,
          minWidth: (appConfig.logo_width || 200) * 1.5
        }}>
          <img
            src="/img/eloNestsymbol.png"
            alt=""
            className="logo-bg-spin absolute"
            style={{
              width: ((appConfig.logo_width || 200) * 1.5) * 0.67,
              height: ((appConfig.logo_height || 80) * 1.5) * 0.67,
              objectFit: 'contain',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 0
            }}
            onError={(event) => { event.target.style.display = 'none'; }}
          />
          <img
            src={appLogoSrc}
            alt={name}
            style={{
              width: (appConfig.logo_width || 200) * 1.5,
              height: (appConfig.logo_height || 80) * 1.5,
              objectFit: 'contain',
              position: 'relative',
              zIndex: 1
            }}
            className="logo-front-zoom"
          />
        </div>
      ) : (
        <div className="flex justify-center items-center mb-4 relative" style={{ minHeight: '180px', minWidth: '300px' }}>
          <img
            src="/img/eloNestLogo.png"
            alt={name}
            className="logo-front-zoom relative"
            style={{ height: '180px', width: 'auto', maxWidth: '450px', zIndex: 1 }}
            onError={(event) => { event.target.style.display = 'none'; }}
          />
          <img
            src="/img/eloNestsymbol.png"
            alt=""
            className="logo-bg-spin absolute"
            style={{
              width: '100px',
              height: '100px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%) translateX(-35%)',
              objectFit: 'contain',
              zIndex: 0
            }}
            onError={(event) => { event.target.style.display = 'none'; }}
          />
        </div>
      )}
      {appConfig?.app_tagline && (
        <p className="mt-2 text-center text-sm text-gray-500">{appConfig.app_tagline}</p>
      )}
    </>
  );
}
